import React, { useState } from 'react';
import { useStaticQuery, graphql} from 'gatsby';
import Modal from 'react-modal';

import ContactForm from './ContactForm';
import Font from '../styles/FontStyle';

Modal.setAppElement('#___gatsby');

export default () => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const data = useStaticQuery(graphql`
        query contactFooter {
            prismicBasicInfo {
                data {
                    orange
                    main_color_two
                    main_color_three
                }
            }
        }
    `);

    const { orange, main_color_two, main_color_three } = data.prismicBasicInfo.data;

    const handleModalClose = () => setIsModalOpen(false);
    const handleModalOpen = () => setIsModalOpen(true);

    return (
        <div style={{margin: '25px 0 50px 0', padding: 50, height: 250, textAlign: 'center'}}>
            
            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleModalClose}
                shouldCloseOnOverlayClick={true}
                style={{
                    overlay: {
                        zIndex: '9999',
                        backgroundColor: 'rgba(0,0,0,.75)',
                    },
                    content : {
                        backgroundColor: orange,
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        borderRadius: '15px 15px 125px 15px',
                        border: 'none'
                      }
                }}
            >
                <button 
                    style={{
                        float: 'right',
                        color: main_color_three,
                        backgroundColor: main_color_two,
                        padding: '5px 12px',
                        borderRadius: '3px 10px 3px 3px',
                        border: 'none',
                        fontFamily: Font.fontFamily,
                        fontWeight: 'bold',
                        cursor: 'pointer'
                    }}
                    onClick={handleModalClose}
                >
                    x
                </button>
                
                <ContactForm button={{text: main_color_three, background: main_color_two, font: Font}} />

            </Modal>
            
            <h2 style={{ marginBottom: 35 }}>Interesse?</h2>
            <button 
                onClick={handleModalOpen}
                className='scale-link'
                style={{
                    color: main_color_three,
                    backgroundColor: main_color_two,
                    border: 'none',
                    padding: 25,
                    maxWidth: 200,
                    borderRadius: '5px 45px 5px 5px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                }}
            >
                Klik hier om contact op te nemen
            </button>
        </div>        
    )
}